module.exports = __webpack_public_path__ + "img/aej1n-66wvl.011.77d41e19.png";